module.exports = "<div><markdown [data]=\"distText\"></markdown></div>\n"